import ActionTypes from '../actions/types';
import { ADMIN_ACCESS, ADMIN_ACCESS_MASK } from '../../utils/constants';

const initialState = {
    sessionUserKey: null,
    loading: true,
    period: 'currentMonth',
    dimension: null,
    r_dimension_1: 'provider',
    r_dimension_2: null,
    r_dimension_3: null,
    filterBy: null,
    dashboardFilters: {scope: null, rules: []},
    touched: false,
    comparison: false,
    publisherView: null,
    filterData: null,
    splitByDay: true,
    isDeal: false,
}

const reportReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch(type){
        case ActionTypes.LOGIN_REQUEST:
        case ActionTypes.LOGIN_SUCCESS:
        case ActionTypes.LOGOUT:
        case ActionTypes.AUTH_ERROR:
        case ActionTypes.LOGIN_FAIL:
            return {...initialState};
        case ActionTypes.USER_LOADED: {
            const user = payload.user;
            const sessionUserKey = JSON.stringify([user._id, user.access, user.subAccount]);
            // Preserve manual publisher switching when refreshing the same profile.
            if (state.sessionUserKey === sessionUserKey) return state;
            return {
                ...initialState,
                sessionUserKey,
                publisherView: user.access === ADMIN_ACCESS
                    ? ADMIN_ACCESS_MASK
                    : user.access.split('+')[0]
            };
        }
        case ActionTypes.GET_DEALS_DATA_SUCCESS:
        case ActionTypes.GET_DATA_SUCCESS: 
            return {
                ...state,
                loading: false
            };

        case ActionTypes.CHANGE_PERIOD: 
            return {
                ...state,
                period: payload,
                touched: true
            };
        case ActionTypes.CHANGE_DIMENSION: 
            return {
                ...state,
                dimension: payload,
                touched: true
            };
        case ActionTypes.R_CHANGE_DIMENSION_1: 
            return {
                ...state,
                r_dimension_1: payload,
                touched: true
            };
        case ActionTypes.R_CHANGE_DIMENSION_2: 
            return {
                ...state,
                r_dimension_2: payload,
                touched: true
            };
        case ActionTypes.R_CHANGE_DIMENSION_3: 
            return {
                ...state,
                r_dimension_3: payload,
                touched: true
            };
        case ActionTypes.CHANGE_FILTER: 
            return {
                ...state,
                filterBy: payload,
                touched: true
            };
        case ActionTypes.CHANGE_DASHBOARD_FILTERS:
            return {
                ...state,
                dashboardFilters: {scope: payload.scope, rules: payload.rules},
                touched: true
            };
        case ActionTypes.CHANGE_PUBLISHER_VIEW: 
            return {
                ...state,
                publisherView: payload,
                touched: true
            };
        case ActionTypes.LOADING_FILTER_DATA: 
            return {
                ...state,
                filterData: payload
            };
        case ActionTypes.SWITCH_COMPARISON_MODE: 
            return {
                ...state,
                comparison: !state.comparison
            };
        case ActionTypes.SWITCH_IS_DEAL: 
            return {
                ...state,
                isDeal: payload
            };
        case ActionTypes.SWITCH_SPLIT_MODE: 
            return {
                ...state,
                splitByDay: !state.splitByDay
            };
        default: 
            return state;
    }
}

export default reportReducer;